/**
 * TEST-39 — <cart-urgency-timer>: countdown naar de 23:00-cutoff in de cart drawer.
 *
 * "Bestel binnen Xu Ym voor levering morgen". Dagrekening identiek aan
 * snippets/icon-with-text.liquid (~r46-69): uur >= 23 -> +2 dagen anders +1,
 * zondag als leverdag overslaan. Elke tick rekent opnieuw vanaf new Date(),
 * dus de rollover om 23:00 corrigeert zichzelf terwijl de drawer openstaat.
 *
 * De cart drawer vervangt bij cart:refresh zijn volledige innerHTML; dit element
 * ruimt daarom zijn interval en listener op in disconnectedCallback en start
 * opnieuw wanneer het nieuwe exemplaar connect.
 *
 * Verwijderplan: experiments/TEST-39-cart-urgency-timer/brief.md.
 */
if (!customElements.get('cart-urgency-timer')) {
  class CartUrgencyTimer extends HTMLElement {
    constructor() {
      super();
      this.days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
      this.onCartUpdated = this.onCartUpdated.bind(this);
    }

    connectedCallback() {
      this.render();
      this.interval = setInterval(() => this.render(), 30000);
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    onCartUpdated(event) {
      const cart = event.detail && event.detail.cart;
      if (!cart) return;
      this.classList.toggle('hidden', cart.item_count === 0);
    }

    render() {
      const textEl = this.querySelector('[data-urgency-text]');
      if (!textEl) return;

      const now = new Date();

      // Eerstvolgende 23:00-cutoff.
      const cutoff = new Date(now);
      cutoff.setHours(23, 0, 0, 0);
      if (now.getHours() >= 23) {
        cutoff.setDate(cutoff.getDate() + 1);
      }

      // Leverdag: zelfde rekening als icon-with-text.liquid / cart-delivery-cutoff-message.liquid.
      const delivery = new Date(now);
      if (now.getHours() >= 23) {
        delivery.setDate(delivery.getDate() + 2);
      } else {
        delivery.setDate(delivery.getDate() + 1);
      }
      if (delivery.getDay() === 0) {
        delivery.setDate(delivery.getDate() + 1);
      }

      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const dayLabel = delivery.toDateString() === tomorrow.toDateString() ? 'morgen' : this.days[delivery.getDay()];

      const minutesLeft = Math.ceil((cutoff - now) / 60000);
      const hours = Math.floor(minutesLeft / 60);
      const minutes = minutesLeft % 60;
      let timeLabel;
      if (hours > 0) {
        timeLabel = minutes > 0 ? hours + 'u ' + minutes + 'm' : hours + 'u';
      } else {
        timeLabel = minutes + 'm';
      }

      textEl.innerHTML = 'Bestel binnen <strong>' + timeLabel + '</strong> voor levering <strong>' + dayLabel + '</strong>';
    }
  }
  customElements.define('cart-urgency-timer', CartUrgencyTimer);
}
